import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Productos from './pages/Productos';
import Categorias from './pages/Categorias';
import Servicios from './pages/Servicios';
import Cotizaciones from './pages/Cotizaciones';
import Resenas from './pages/Resenas';
import Informacion from './pages/Informacion';
import AgenteIA from './pages/AgenteIA';
import Distribuidores from './pages/Distribuidores';
import Tecnico from './pages/Tecnico';
import Mercadeo from './pages/Mercadeo';
import Marcas from './pages/Marcas';
import Emojis from './pages/Emojis';
import Bci from './pages/Bci';
import Banners from './pages/Banners';
import BannerTexto from './pages/BannerTexto';
import Descargas from './pages/Descargas';
import GoogleMedicion from './pages/GoogleMedicion';
import Rifa from './pages/Rifa';
import RifaPantalla from './pages/RifaPantalla';
import Clientes from './pages/Clientes';
import Layout from './components/Layout';

const ProtectedRoute = ({ children }: { children: any }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/rifa/pantalla/:id" element={<ProtectedRoute><RifaPantalla /></ProtectedRoute>} />
        <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="productos" element={<Productos />} />
          <Route path="categorias" element={<Categorias />} />
          <Route path="servicios" element={<Servicios />} />
          <Route path="cotizaciones" element={<Cotizaciones />} />
          <Route path="resenas" element={<Resenas />} />
          <Route path="informacion" element={<Informacion />} />
          <Route path="agente-ia" element={<AgenteIA />} />
          <Route path="distribuidores" element={<Distribuidores />} />
          <Route path="tecnico" element={<Tecnico />} />
          <Route path="mercadeo" element={<Mercadeo />} />
          <Route path="marcas" element={<Marcas />} />
          <Route path="emojis" element={<Emojis />} />
          <Route path="bci" element={<Bci />} />
          <Route path="banners" element={<Banners />} />
          <Route path="descargas" element={<Descargas />} />
          <Route path="banner-texto" element={<BannerTexto />} />
          <Route path="google" element={<GoogleMedicion />} />
          <Route path="rifa" element={<Rifa />} />
          <Route path="clientes" element={<Clientes />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
